<template>
  <div class="menu-side">
    <div>
      <div class="menu-side-title">
        <img class="icon-back" src="../../assets/imgs/drawer/icon_back.png" alt="" @click="onClick('hide_menu')">
        <div class="user-info">
          <img src="../../assets/imgs/avatar.png" alt="" />
          <span v-if="user && user.pname">{{ user.pname }}</span>
          <span v-else @click="goRouter('/login')">{{ i18n.login_tips }}</span>
          <!-- <span class="user-info-edit">{{ i18n.edit_profile }}</span> -->
        </div>
      </div>

      <div class="menu-side-row" @click="goRouter('/order')">
        <img src="../../assets/imgs/drawer/icon_order.png" alt="">
        <span>{{ i18n.rental_history }}</span>
      </div>
      <!-- <div class="menu-side-row" @click="goRouter('/wallet')">
        <img src="../../assets/imgs/drawer/icon_payment.png" alt="">
        <span>{{ i18n.wallet }}</span>
      </div> -->
      <div class="menu-side-row" @click="goRouter('/help')">
        <img src="../../assets/imgs/drawer/icon_help.png" alt="">
        <span>{{ i18n.help }}</span>
      </div>
      <div class="menu-side-row" @click="goRouter('/download')">
        <img src="../../assets/imgs/drawer/icon_refer.png" alt="">
        <span>{{ i18n.download_app }}</span>
      </div>
      <div class="menu-side-row" @click="onClick('join_us')">
        <img src="../../assets/imgs/drawer/icon_host.png" alt="">
        <span>{{ i18n.join_us }}</span>
      </div>
      <div class="menu-side-row" @click="goRouter('/setting')">
        <img src="../../assets/imgs/drawer/icon_settings.png" alt="">
        <span>{{ i18n.settings }}</span>
      </div>
      <!-- <div class="menu-side-line"></div> -->
      <div class="menu-side-row" @click="onLogout">
        <img src="../../assets/imgs/drawer/icon_order.png" alt="">
        <span>{{ i18n.logout }}</span>
      </div>
  </div>
    <!-- <div class="menu-side-foot"></div> -->
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  computed: {
    ...mapState(["user"]),
    i18n() {
      return this.$t("mine")
    }
  },
  methods: {
    onClick(type) {
      if (type === "hide_menu") {
        this.$parent.$parent.isMenuView = false
      }
      if (type === "join_us") {
        let domain = process.env.VUE_APP_DOMAIN.replace("//m.", "//www.")
        window.open(domain)
      }
    },
    onLogout() {
      this.$store.commit("user", null)
      this.$store.commit("token", "")
      this.$router.push("/login")
    },
    goRouter(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="less">
@bgColor: #232323;
.icon-back {
  width: 80px;
  height: 80px;
  margin-bottom: 50px;
}
.menu-side-bg {
  background: @bgColor;
  margin: 40px;
  border-radius: 20px;
  // border: 1Px solid #d5d5d5;
}
.menu-side {
  width: 70vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #000;
  // border-radius: 0 0 210px 0;
  color: #fff;

  &-title {
    display: flex;
    flex-flow: column;
    align-items: start;
    justify-content: flex-start;
    padding: 40px 53px 32px;
  }
  .user-info {
    display: flex;
    align-items: center;
    justify-content: start;
    font-size: 42px;
    img {
      width: 88px;
      height: 88px;
      margin-right: 20px;
      border-radius: 50%;
      margin-bottom: 26px;
    }
    &-edit {
      font-size: 24px;
    }
  }

  &-row {
    font-size: 32px;
    display: flex;
    align-items: center;
    justify-content: start;
    height: 88px;
    width: 100%;
    margin: 0 auto;
    color: #fff;
    img {
      width: 49px;
      height: 49px;
      margin: 0 21px 0 53px;
    }
  }
  &-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    background: @bgColor;
    border-radius: 20px;
    margin: 0 40px;
    // border: 1Px solid #d5d5d5;
  }
  &-item {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    color: #fff;
    img {
      width: 100px;
      height: 100px;
    }
    span {
      text-align: center;
    }
  }

  &-foot {
    width: 100%;
    display: flex;
    justify-content: end;
    img {
      width: 63px;
      height: 63px;
      margin: 40px 105px 88px 53px;
    }
  }
  &-line {
    // width: 60%;
    margin: 20px 53px;
    border-bottom: 2px solid rgba(235, 235, 235, 0.2);
  }
}
</style>
